<template>
  <div v-if="false"></div>
</template>

<script>
  export default {
    name: "vf-drawer-item"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// vf-drawer-item.vue?b1dc2618